import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationDE from './locales/de/translation.json';
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';

// Les ressources des langues
const resources = {
  de: {
    translation: translationDE
  },
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  }
};

// Initialisation de i18n
i18n
  .use(initReactI18next) // Pour passer i18n à react-i18next
  .init({
    resources,
    lng: 'fr', // Langue par défaut
    fallbackLng: 'en', // Langue de secours si la traduction est absente
    interpolation: {
      escapeValue: false // React protège automatiquement contre les injections XSS
    }
  });

export default i18n;
